// @flow
import OfficeInformationModalContainer from './OfficeInformationModalContainer'
export default OfficeInformationModalContainer
